import {camelCase} from 'lodash';
import findPathInNestedObject from '@/utils/findPathInNestedObject';
import PERMISSIONS from '@/config/permissions';
import {PermissionObject, RequestedPermission} from '@/types/permissions';

function permissionComparator(
  userPermissions: PermissionObject[],
  requestedPermission: PermissionObject
): PermissionObject | undefined {
  return userPermissions.find(
    (p) =>
      p.subjectClass === requestedPermission.subjectClass &&
      p.action === requestedPermission.action
  );
}

/**
 * Pure function that checks requested permissions against user permissions.
 * Returns an object with camelCase keys mapping each permission to a boolean.
 */
export default function getDashboardUserPermissions(
  requestedPermissions: RequestedPermission[],
  userPermissions?: PermissionObject[]
): Record<string, boolean> {
  if (!userPermissions) return {};

  return requestedPermissions.reduce(
    (acc: Record<string, boolean>, permission: RequestedPermission) => {
      const permissionPath =
        findPathInNestedObject(PERMISSIONS, permission) || [];
      const permissionKey = camelCase(permissionPath.reverse().join('-'));
      if (!permissionKey) return acc;

      if (Array.isArray(permission)) {
        acc[permissionKey] = permission.every(
          (p) => !!permissionComparator(userPermissions, p)
        );
      } else {
        acc[permissionKey] = !!permissionComparator(
          userPermissions,
          permission
        );
      }
      return acc;
    },
    {} as Record<string, boolean>
  );
}
